import React, { useState } from 'react';
import infoIcon from '../../../../../assets/infoG.svg';

interface RulesetSlideProps {
  onAddRuleset: (ruleset: string) => void;
  onRemoveRuleset: (index: number) => void;
  rulesets: string[];
}

const RulesetSlide: React.FC<RulesetSlideProps> = ({
  onAddRuleset,
  onRemoveRuleset,
  rulesets
}) => {
  const [inputValue, setInputValue] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const handleAddRuleset = () => {
    const trimmedRuleset = inputValue.trim();
    if (trimmedRuleset) {
      if (rulesets.some(r => r.toLowerCase() === trimmedRuleset.toLowerCase())) {
        setErrorMessage('This ruleset already exists');
        return;
      }
      setErrorMessage('');
      onAddRuleset(trimmedRuleset);
      setInputValue('');
    }
  };

  const handleSuggestionClick = (suggestion: string) => {
    setInputValue(suggestion);
    setErrorMessage('');
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      handleAddRuleset();
    }
  };

  const suggestions = [
    'Should contain XYZ Tech',
    'Lead qualification score is greater than 80',
    'Location is San Francisco',
    'Companies employees is 50-200',
    'User activity is not unsubscribed'
  ];

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col gap-1">
        <div className="flex flex-col w-full bg-[#388E3C] rounded-[9px] pl-[9px] py-[1px] pr-[1px]">
          <div className="flex items-center text-left gap-2 bg-[#FFFFFF] rounded-r-[8px] px-[4px] py-[4px]">
            <img src={infoIcon} alt="info" className="w-[12px] h-[12px] mr-[4px] text-[#388E3C]" />
            <p className="text-[12px] font-medium text-[#388E3C]">
              Rulesets help filter leads based on your preferences. Below are some suggestions
            </p>
          </div>
        </div>
        <div className="flex flex-col gap-2">
          <div className="flex items-center gap-2 mt-[24px]">
            <input
              type="text"
              value={inputValue}
              onChange={(e) => {
                setInputValue(e.target.value);
                setErrorMessage('');
              }}
              onKeyPress={handleKeyPress}
              placeholder="Enter ICP"
              className="flex p-[16px] h-[34px] w-full border text-[14px] font-normal border-[#DDDDDD] rounded-[10px] focus:outline-none focus:ring-1 focus:ring-[#42E56F] text-[#222222] placeholder-[#9FA1A7] placeholder:text-[14px] placeholder:font-normal"
            />
            <button
              onClick={handleAddRuleset}
              disabled={!inputValue.trim()}
              className={`h-[34px] whitespace-nowrap px-3 text-[14px] rounded-[8px] font-normal ${
                inputValue.trim() 
                  ? 'bg-[#29DC5B] text-[#222222] hover:bg-[#0FAA3A]' 
                  : 'bg-[#FAFAFA] text-[#222222] cursor-not-allowed'
              }`}
            >
              + Add ICP
            </button>
          </div>
          {errorMessage && (
            <p className="text-[12px] text-[#DC2626] text-left mt-[2px] ml-1">{errorMessage}</p>
          )}
        </div>
      </div>

      <div className="w-full h-[162px] bg-[#FAFAFA] rounded-[8px] p-[16px] overflow-y-auto scrollbar-hide">
        <p className="text-[12px] font-medium text-[#000000] mb-2 text-left">
          Your added ICP ruleset
        </p>
        <div className="flex flex-wrap gap-2 overflow-y-auto max-h-[108px] scrollbar-hide">
          {rulesets.map((ruleset, index) => (
            <div
              key={index}
              className="px-3 py-1 bg-[#E5F9FF] text-[#0891B2] rounded-[8px] text-[14px] flex items-center gap-2"
            >
              {ruleset}
              <button
                onClick={() => onRemoveRuleset(index)}
                className="text-current hover:text-opacity-70"
              >
                ×
              </button>
            </div>
          ))}
        </div>
      </div>

      <div>
        <p className="text-[12px] font-light text-[#000000] mb-3 pl-[6px] text-left">
          Or, choose a suggestion below
        </p>
        <div className="flex flex-wrap gap-2">
          {suggestions.map((suggestion, index) => (
            <button
              key={index}
              onClick={() => handleSuggestionClick(suggestion)}
              className="px-3 py-1 bg-[#F5F5F5] hover:bg-[#EEEEEE] rounded-[8px] text-[14px] text-[#222222]"
            >
              {suggestion}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default RulesetSlide; 